import { Card, CardBody, CardHeader, CardTitle } from '@/common'
import useI18n from '@/shared/hooks/usei18n'
import type { SupplierEmissionsReport } from '@/features/suppliers/hooks/supplierEmissionsReport'

type CbamGoodCalculationMethodSectionProps = {
  isUsingDefaultEmissions: boolean
  supplierEmissionsReport: SupplierEmissionsReport | null
}

export default function CbamGoodCalculationMethodSection({
  isUsingDefaultEmissions,
  supplierEmissionsReport
}: CbamGoodCalculationMethodSectionProps) {
  const { t } = useI18n()

  return (
    <Card>
      <CardHeader>
        <CardTitle
          title={t(
            'cbamReporting:cbamReportDetails.reportedGoods.importedGoodDetailsDrawer.sections.calculationMethodAndEvidence'
          )}
        />
      </CardHeader>
      <CardBody>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-sm text-text-secondary mb-1">
              {t(
                'cbamReporting:cbamReportDetails.reportedGoods.importedGoodDetailsDrawer.fields.calculationAndEvidence'
              )}
            </div>
            <div>
              {isUsingDefaultEmissions ? (
                <div>
                  <div className="font-medium mb-1">
                    {t(
                      'cbamReporting:cbamReportDetails.reportedGoods.importedGoodDetailsDrawer.calculationMethod.default'
                    )}
                  </div>
                </div>
              ) : (
                <div>
                  <div className="font-medium mb-1">
                    {t(
                      'cbamReporting:cbamReportDetails.reportedGoods.importedGoodDetailsDrawer.calculationMethod.actual'
                    )}
                  </div>
                  {supplierEmissionsReport && (
                    <div className="text-sm text-text-secondary">
                      {t(
                        'cbamReporting:cbamReportDetails.reportedGoods.importedGoodDetailsDrawer.calculationMethod.emissionsReport'
                      )}
                      {supplierEmissionsReport.evidenceFileName && (
                        <span>: {supplierEmissionsReport.evidenceFileName}</span>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}
